module.exports = "<div class=\"row\">\n  <div class=\"col-sm-12\">\n      <!-- <app-master-spinner></app-master-spinner>  -->\n      <!-- Basic Inputs Validation start -->\n\n\n\n      <app-card [title]=\"'Calendario'\" [headerContent]=\"''\" [cardOptionBlock]=\"true\">\n        <ejs-schedule [currentView]='setView'></ejs-schedule>\n          \n      </app-card>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-task/master-task.component.html
// module id = ./src/app/master/master-task/master-task.component.html
// module chunks = main